<template>
  <div>
    <stacked-input
      :label="i18n.budget"
      :required="required"
      :error="errors.budget"
      :help="options.min + ' → ' + options.max"
    >
      <input
        type="number"
        :required="required"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :min="options.min"
        :max="options.max"
      />
    </stacked-input>

    <details class="bg-gray-100 text-sm mt-1 p-2 text-primary cursor-pointer">
      <summary v-text="summary(i18n.help_1)" />
      <p v-html="details(i18n.help_1)" />
    </details>

    <details class="bg-gray-100 text-sm mt-1 p-2 text-primary cursor-pointer">
      <summary v-text="summary(i18n.help_2)" />
      <p v-html="details(i18n.help_2)" />
    </details>
  </div>
</template>

<script>
import StackedInput from "../../../../Design/Forms/StackedInput";

export default {
  props: ["i18n", "required", "value", "errors", "options"],
  components: { StackedInput },
  computed: {
    summary() {
      return (text) => {
        const firstDot = text.indexOf(".");
        return text.substr(0, firstDot) + "...";
      };
    },
    details() {
      return (text) => {
        const firstDot = text.indexOf(".");
        return text.substr(firstDot + 2);
      };
    },
  },
};
</script>
